/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */

import { Button, Stack } from '@mui/material';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { useState } from 'react';
import { DeviceManageButtons } from './device-manage-buttons';
import Iconify from '../iconify';
import AddPlayList from '../playlist-modal/playlist';
import AddXCPlayList from '../playlist-modal/xcPlaylist';
import { useBoolean } from '../hooks/use-boolean';
import PlaylistDelete from '../playlist-modal/playlist-delete';
import Label from '../label';
import { TableHeadCustom } from '../table-head-custom';

const TABLE_HEAD = [
  { id: 'name', label: 'Name', width: 150 },
  { id: 'url', label: 'URL', align: 'left' },
  { id: 'playlist_type', label: 'Type', align: 'left' },
  { id: 'action-button', label: '', align: 'center' },
];

export const PlaylistManage = ({ device, tableData, refresh }) => {
  const [defaultValues, setDefaultValues] = useState({});
  const dialog = useBoolean();
  const dialogXC = useBoolean();
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const confirmed = useBoolean(false);

  const deleteDialog = useBoolean();

  const resetId = () => {
    setSelectedPlaylist(null);
  };

  const getPlaylistType = row => {
    if (row.playlist_type === 'xc') {
      return 'XC';
    }
    try {
      const playlist_url = row.url;

      const parsedUrl = new URL(playlist_url);
      const { pathname } = parsedUrl;
      const pathSegments = pathname.split('/').filter(Boolean);

      if (
        pathSegments.length >= 2 ||
        (playlist_url.includes('username=') && playlist_url.includes('password='))
      ) {
        return 'XC';
      }

      return 'Non-XC';
    } catch (e) {
      return '';
    }
  };

  return (
    <Stack
      gap={4}
      marginBottom={6}
      sx={{
        flexDirection: {
          sm: 'column',
          md: 'row',
        },
      }}
    >
      <DeviceManageButtons device={device} />
      <Stack flexGrow={1} gap={3}>
        <Stack flexDirection="row" gap={1.5}>
          <AddPlayList
            device={device}
            refresh={refresh}
            defaultV={defaultValues}
            dialog={dialog}
            resetId={resetId}
            selectedPlaylist={selectedPlaylist}
            confirmed={confirmed}
          />
          <AddXCPlayList
            device={device}
            refresh={refresh}
            defaultV={defaultValues}
            dialog={dialogXC}
            resetId={resetId}
            selectedPlay
            selectedPlaylist={selectedPlaylist}
            confirmed={confirmed}
          />
          <PlaylistDelete
            device={device}
            refresh={refresh}
            dialog={deleteDialog}
            selectedPlaylist={selectedPlaylist}
          />
        </Stack>
        <Stack
          sx={{
            maxWidth: {
              xs: 'calc(100vw - 48px)',
              sm: 'calc(100vw - 48px)',
              md: 'unset',
            },
          }}
        >
          <Card sx={{ width: 1 }}>
            <CardHeader title="Added Playlists" />
            <TableContainer sx={{ mt: 3, overflow: 'auto' }}>
              <Table>
                <TableHeadCustom headLabel={TABLE_HEAD} />

                {tableData.length > 0 && (
                  <TableBody>
                    {tableData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.playlist_name}</TableCell>
                        <TableCell align="left">
                          {row.created_by || row.is_protected ? (
                            <Label variant="outlined" color="error">
                              Protected
                            </Label>
                          ) : (
                            row.url
                          )}
                        </TableCell>
                        <TableCell align="left">
                          <Label variant="soft" color="success">
                            {getPlaylistType(row)}
                          </Label>
                        </TableCell>
                        <TableCell align="right">
                          {!row?.created_by && (
                            <Stack gap={1}>
                              <Button
                                startIcon={<Iconify icon="basil:edit-outline" />}
                                size="medium"
                                variant="outlined"
                                color="info"
                                onClick={() => {
                                  if (row.playlist_type === 'xc') {
                                    const defaultValues = {
                                      playlistName: row.playlist_name,
                                      playlistHost: row.url,
                                      userName: row.username,
                                      password: row.password,
                                      isProtect: row.is_protected,
                                      pin: row.is_protected ? row.pin : '',
                                      confirmPin: row.is_protected ? row.pin : '',
                                      checkPin: '',
                                    };
                                    setSelectedPlaylist(row);
                                    setDefaultValues(defaultValues);
                                    confirmed.onFalse();
                                    dialogXC.onTrue();
                                  } else {
                                    const defaultValues = {
                                      playlistName: row.playlist_name,
                                      playlistUrl: row.url,
                                      isProtect: row.is_protected,
                                      pin: row.is_protected ? row.pin : '',
                                      confirmPin: row.is_protected ? row.pin : '',
                                      checkPin: '',
                                    };
                                    setSelectedPlaylist(row);
                                    setDefaultValues(defaultValues);
                                    confirmed.onFalse();
                                    dialog.onTrue();
                                  }
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                startIcon={<Iconify icon="fluent:delete-20-regular" />}
                                size="medium"
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  setSelectedPlaylist(row);
                                  deleteDialog.onTrue();
                                }}
                              >
                                Delete
                              </Button>
                            </Stack>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Card>
        </Stack>
      </Stack>
    </Stack>
  );
};
